import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../../utl/models/Error";
import { ServiceState } from "../models/ServiceState";

const setError = (state: ServiceState, action: PayloadAction<Error>) => {
    state.isError = action.payload.error;
    state.isLoading = false;
}

export default setError;